const NotFound = () => {
    return (
      <section>
        <img src='https://i.imgur.com/uq2UeKI.jpg' alt='Error: lost in space' />
        <h1>Lost in time and space</h1>
      </section>
    )
  }
  
  export default NotFound